import { render, staticRenderFns } from "./ZavaBenefits.vue?vue&type=template&id=335c4cf3"
import script from "./ZavaBenefits.vue?vue&type=script&lang=js"
export * from "./ZavaBenefits.vue?vue&type=script&lang=js"
import style0 from "./ZavaBenefits.vue?vue&type=style&index=0&id=335c4cf3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports